import "./BasementRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import BasementRemodelingHero from "./sections/BasementRemodelingHero";
import BasementPlanning from "./sections/BasementPlanning";
import BasementCtaBand from "./sections/BasementCtaBand";
import BasementTimeline from "./sections/BasementTimeline";
import RemodelingProcess from "./sections/RemodelingProcess";
import BasementRemodelingFaq from "./sections/BasementRemodelingFaq";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import BasementCta from "./sections/BasementCta";
import Footer from "@/reusable_sections/Footer";
export default function BasementRemodelingPage() {
  return <div>
      <Header />
      <BasementRemodelingHero />
      <BasementPlanning />
      <BasementCtaBand />
      <BasementTimeline />
      <RemodelingProcess />
      <BasementRemodelingFaq />
      <EstimateRequestForm />
      <BasementCta />
      <Footer />
    </div>;
}